module.exports = __webpack_public_path__ + "static/media/amber-cafe@3x.04fc1e99.png";